import(/* webpackMode: "eager", webpackExports: ["Providers"] */ "/vercel/path0/web/app/providers.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["WebTracker"] */ "/vercel/path0/web/components/analytics/WebTracker.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/web/node_modules/next/font/local/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"\",\"arguments\":[{\"src\":\"./fonts/space-grotesk.woff2\",\"weight\":\"300 700\",\"display\":\"swap\",\"variable\":\"--font-display\"}],\"variableName\":\"spaceGrotesk\"}");
;
import(/* webpackMode: "eager" */ "/vercel/path0/web/node_modules/next/font/local/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"\",\"arguments\":[{\"src\":\"./fonts/hanken-grotesk.woff2\",\"weight\":\"100 900\",\"display\":\"swap\",\"variable\":\"--font-body\"}],\"variableName\":\"hankenGrotesk\"}");
;
import(/* webpackMode: "eager" */ "/vercel/path0/web/node_modules/next/font/local/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"\",\"arguments\":[{\"src\":\"./fonts/jetbrains-mono.woff2\",\"weight\":\"100 800\",\"display\":\"swap\",\"variable\":\"--font-jetbrains\"}],\"variableName\":\"jetbrainsMono\"}");
;
import(/* webpackMode: "eager" */ "/vercel/path0/web/app/globals.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/web/node_modules/@signalmax/ui/tokens/tokens.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/web/node_modules/@signalmax/ui/styles/fonts.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/web/node_modules/@signalmax/ui/styles/primitives.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/web/node_modules/@signalmax/ui/styles/composed.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/web/node_modules/@signalmax/ui/styles/data.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/web/node_modules/@signalmax/ui/styles/forms.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/web/node_modules/@signalmax/ui/styles/feedback.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/web/node_modules/@signalmax/ui/styles/domain.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/web/node_modules/@signalmax/ui/styles/shell.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/web/node_modules/@signalmax/ui/styles/polish.css");
